import { getAnalyticsWebClient } from '@helpCenter/util/analytics';

export const sendTrackEvent = ({
    action,
    actionSubject,
    actionSubjectId,
    attributes,
}: {
    action: string;
    actionSubject: string;
    attributes?: { [x: string]: string | undefined };
    actionSubjectId?: string;
}) => {
    const analyticsClient = getAnalyticsWebClient().getInstance();
    analyticsClient
        .sendTrackEvent({
            action,
            actionSubject,
            actionSubjectId,
            attributes,
            source: 'virtualAgent',
        })
        .catch((error: string) => {
            throw new Error(`Failure to send analytics event ${error}`);
        });
};

export const sendErrorAnalytics = ({
    error,
    actionSubject,
    actionSubjectId,
}: {
    error: Error;
    actionSubject: string;
    actionSubjectId?: string;
}) => {
    const analyticsClient = getAnalyticsWebClient().getInstance();
    analyticsClient
        .sendOperationalEvent({
            actionSubject,
            actionSubjectId,
            action: 'failed',
            source: 'virtualAgent',
            attributes: {
                error,
            },
        })
        .catch((err: string) => {
            throw new Error(`Failure to send analytics event ${err}`);
        });
};
